// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.kelp",
    name: "Kelp",
    homepage: "https://kelp.org",
    image_id: "1854e47d-3804-4e92-e455-06829b64b100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/kelp/id1632857274",
        android: "https://play.google.com/store/apps/details?id=com.app.kelpa",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "link.kelp.finance://walletconnect",
        universal: "https://link.kelp.finance/walletconnect",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map